import axios from "@/utils/request";

/**
 * Page信息
 * @param query
 */
export function fetchList (data: any) {
    return axios({
        path: '/onlineMedical/medicalComp/down/page',
        data
    })
}

export function getTaskItems(id:string) {
    return axios({
        path: '/onlineMedical/medicalComp/down/getTaskItems/'+ id,
        method: 'get'
    })
}

export function getTaskMedical(id:string) {
    return axios({
        path: '/onlineMedical/medicalComp/down/getTaskMedical/'+ id,
        method: 'get'
    })
}

export function getTaskMedicalDetail(id:string) {
    return axios({
        path: '/onlineMedical/medicalComp/down/getMedicalTaskDetail/'+ id,
        method: 'get'
    })
}


export const  del = (data:any)=>{
    return axios({
        path: '/onlineMedical/medicalComp/down/updateTask',
        method:"POST",
        data
    })
}